var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sw-login" }, [
    _c("div", { staticClass: "sw-login-wrap" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { id: "background" }
      }),
      _c("div", { attrs: { id: "logo" } }),
      _c("div", { attrs: { id: "language" } }),
      _c(
        "div",
        {
          staticClass: "sw-login-main",
          class: {
            "login-notice-show-mode":
              _vm.config.loginNoticeShowMode == "2" &&
              _vm.config.loginNoticeContent
          }
        },
        [
          _c("div", { staticClass: "sw-login-main-content" }, [
            _vm.config.qrCodeEnabled
              ? _c(
                  "div",
                  {
                    staticClass: "qrcode-button",
                    on: { click: _vm.openOrCloseQrCode }
                  },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isQrcode,
                          expression: "!isQrcode"
                        }
                      ],
                      staticClass: "qrcode-button-img iconfont icon-banma",
                      style: { color: "#" + _vm.config.schemeColor }
                    }),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isQrcode,
                          expression: "isQrcode"
                        }
                      ],
                      staticClass:
                        "qrcode-button-img2 iconfont icon-bangediannao",
                      style: { color: "#" + _vm.config.schemeColor }
                    })
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isQrcode,
                    expression: "!isQrcode"
                  }
                ]
              },
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "sw-login-menu",
                    attrs: {
                      "default-active": _vm.currentMenu,
                      "text-color": "#666",
                      "active-text-color": "#" + _vm.config.schemeColor,
                      mode: "horizontal"
                    },
                    on: { select: _vm.changeMenu }
                  },
                  [
                    _c("el-menu-item", { attrs: { index: "1" } }, [
                      _vm._v("账号密码登录")
                    ]),
                    _vm.config.smsCodeEnabled
                      ? _c(
                          "el-menu-item",
                          {
                            staticStyle: { margin: "0 0 0 20px" },
                            attrs: { index: "2" }
                          },
                          [_vm._v("手机验证码登录")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentMenu == 1,
                        expression: "currentMenu==1"
                      }
                    ]
                  },
                  [_c("div", { attrs: { id: "passwordLogin" } })]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentMenu == 2,
                        expression: "currentMenu==2"
                      }
                    ]
                  },
                  [_c("div", { attrs: { id: "smsCodeLogin" } })]
                ),
                _c("div", { attrs: { id: "quickLink" } }),
                _c("div", { attrs: { id: "federatedLogin" } })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isQrcode,
                    expression: "isQrcode"
                  }
                ]
              },
              [_c("div", { attrs: { id: "scanLogin" } })]
            )
          ]),
          _c("div", { attrs: { id: "notice" } })
        ]
      ),
      _c("div", { attrs: { id: "announcement" } }),
      _c("div", { attrs: { id: "noticeBoard" } }),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "guide-browser" }, [
        _c("div", { attrs: { id: "customLink" } }),
        _c("div", { attrs: { id: "browserSupport" } })
      ]),
      _c("div", { attrs: { id: "copyright" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }